module.exports = __webpack_public_path__ + "static/39-Huwai-b43a5056cecde0f0be2f1025e4489ce6.png";